import styled from 'styled-components';

export const ErrorWrapper = styled.span`
  margin: 0.75em 1em;
  font-size: 14px;

  a {
    font-weight: 600;
    color: ${({ theme }) => theme.color.errorLink};

    &:hover {
      color: ${({ theme }) => theme.color.errorLinkHover};
    }
  }
`;
